import React, { Component } from 'react';

import HeaderComponent from '../headers/HeaderComponent';
import './auth.scss'

class DefaultComponent extends Component{

	constructor(props){
		super(props);
	}

  downloadApp = () => {
    window.open(`https://www.hyperpure.com/downloads/apk/delivery`, "_self");
  }

	render(){
		return (
			<React.Fragment>
				<HeaderComponent />
				<div className="auth-container pd-top-global">
					<div className="auth-head">
		                {
		                    
		                    <span className={"auth-head__title fs-28"}>
		                       The Web App has been deprecated. 
		                    </span> 
		                }
		                {
		                    <div className="auth-head__subhead">Click the Download button to download the App</div> 
		                    
		                }
		            
		                
	                </div>
	                <button type="submit" className="btn btn-red" onClick={this.downloadApp}>
                  Download
                  </button>
    			</div>
			</React.Fragment>
		)
	}
}

export default DefaultComponent;
